import { CALL_API } from '../middleware/api'

export const SYNC_ORPHANED_REQUEST = 'SYNC_ORPHANED_REQUEST'
export const SYNC_ORPHANED_SUCCESS = 'SYNC_ORPHANED_SUCCESS'
export const SYNC_ORPHANED_FAILURE = 'SYNC_ORPHANED_FAILURE'

export function fetchOrphanedRecords() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'sync/orphaned',
      authenticated: true,
      types: [SYNC_ORPHANED_REQUEST, SYNC_ORPHANED_SUCCESS, SYNC_ORPHANED_FAILURE]
    }
  }
}

export const SYNC_CUSTOMER_REQUEST = 'SYNC_CUSTOMER_REQUEST'
export const SYNC_CUSTOMER_SUCCESS = 'SYNC_CUSTOMER_SUCCESS'
export const SYNC_CUSTOMER_FAILURE = 'SYNC_CUSTOMER_FAILURE'

export function syncCustomerToAuth(customerId) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `sync/customer/${customerId}`,
      authenticated: true,
      types: [SYNC_CUSTOMER_REQUEST, SYNC_CUSTOMER_SUCCESS, SYNC_CUSTOMER_FAILURE]
    }
  }
}

export const SYNC_USER_REQUEST = 'SYNC_USER_REQUEST'
export const SYNC_USER_SUCCESS = 'SYNC_USER_SUCCESS'
export const SYNC_USER_FAILURE = 'SYNC_USER_FAILURE'

export function syncUserToAuth(userId) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `sync/user/${userId}`,
      authenticated: true,
      types: [SYNC_USER_REQUEST, SYNC_USER_SUCCESS, SYNC_USER_FAILURE]
    }
  }
}

export const SYNC_BULK_REQUEST = 'SYNC_BULK_REQUEST'
export const SYNC_BULK_SUCCESS = 'SYNC_BULK_SUCCESS'
export const SYNC_BULK_FAILURE = 'SYNC_BULK_FAILURE'

export function syncBulkToAuth() {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'sync/bulk',
      authenticated: true,
      types: [SYNC_BULK_REQUEST, SYNC_BULK_SUCCESS, SYNC_BULK_FAILURE]
    }
  }
}

// Reverse sync actions: Import from Auth to local database
export const IMPORT_USER_FROM_AUTH_REQUEST = 'IMPORT_USER_FROM_AUTH_REQUEST'
export const IMPORT_USER_FROM_AUTH_SUCCESS = 'IMPORT_USER_FROM_AUTH_SUCCESS'
export const IMPORT_USER_FROM_AUTH_FAILURE = 'IMPORT_USER_FROM_AUTH_FAILURE'

export function importUserFromAuth(authId) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `sync/from-auth/user/${authId}`,
      authenticated: true,
      types: [IMPORT_USER_FROM_AUTH_REQUEST, IMPORT_USER_FROM_AUTH_SUCCESS, IMPORT_USER_FROM_AUTH_FAILURE]
    }
  }
}

export const IMPORT_CUSTOMER_FROM_AUTH_REQUEST = 'IMPORT_CUSTOMER_FROM_AUTH_REQUEST'
export const IMPORT_CUSTOMER_FROM_AUTH_SUCCESS = 'IMPORT_CUSTOMER_FROM_AUTH_SUCCESS'
export const IMPORT_CUSTOMER_FROM_AUTH_FAILURE = 'IMPORT_CUSTOMER_FROM_AUTH_FAILURE'

export function importCustomerFromAuth(authId) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `sync/from-auth/customer/${authId}`,
      authenticated: true,
      types: [IMPORT_CUSTOMER_FROM_AUTH_REQUEST, IMPORT_CUSTOMER_FROM_AUTH_SUCCESS, IMPORT_CUSTOMER_FROM_AUTH_FAILURE]
    }
  }
}

export const FETCH_AUTH_ORPHANED_REQUEST = 'FETCH_AUTH_ORPHANED_REQUEST'
export const FETCH_AUTH_ORPHANED_SUCCESS = 'FETCH_AUTH_ORPHANED_SUCCESS'
export const FETCH_AUTH_ORPHANED_FAILURE = 'FETCH_AUTH_ORPHANED_FAILURE'

export function fetchAuthOrphanedRecords() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'sync/orphaned-auth',
      authenticated: true,
      types: [FETCH_AUTH_ORPHANED_REQUEST, FETCH_AUTH_ORPHANED_SUCCESS, FETCH_AUTH_ORPHANED_FAILURE]
    }
  }
}
